import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const WHATSAPP_NUMBER = "905078664360";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}`;
export const PHONE_DISPLAY = "0507 866 43 60";
export const CLUB_NAME = "FOCUS SPOR KULÜBÜ";
export const CLUB_SHORT = "FCS";
export const CLUB_LOCATION = "Tuzla / İstanbul";
export const CLUB_FOUNDED = "2025";
export const CLUB_PRESIDENT = "VEDAT COŞKUN";
